(() => {
  const selector = '.zt-collection-controls details';
  const closeOutside = target => {
    document.querySelectorAll(`${selector}[open]`).forEach(disclosure => {
      if (!disclosure.contains(target)) disclosure.open = false;
    });
  };
  document.addEventListener('click', event => closeOutside(event.target));
  document.addEventListener('focusin', event => closeOutside(event.target));
  document.addEventListener('toggle', event => {
    if (!event.target.matches?.(selector) || !event.target.open) return;
    document.querySelectorAll(selector).forEach(disclosure => {
      if (disclosure !== event.target) disclosure.open = false;
    });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const disclosure = event.target.closest?.(`${selector}[open]`);
    if (!disclosure) return;
    disclosure.open = false;
    disclosure.querySelector('summary').focus();
    event.preventDefault();
  });
})();
